<template>
  <w-page :layout="layout" :aria-label="i18n.gettext('Product list')">
    <w-category-list></w-category-list>
  </w-page>
</template>

<script>
import { mapGetters } from 'vuex';

import i18n from '../../i18n';
import { Route } from '../../enums';
import { getProductLinkId } from '../../utils';
import { findFocusableElements } from '../../directives/focus';

import Page from '../Page';

import CategoryList from './CategoryList';

function restoreFocus(categoryId) {
  const categorySection = document.querySelector(categoryId);
  if (categorySection) {
    const { first: firstFocusableElement } =
      findFocusableElements(categorySection);
    if (firstFocusableElement) {
      firstFocusableElement.focus();
    }
  }
}

export default {
  data() {
    return {
      i18n,
    };
  },
  computed: {
    ...mapGetters(['hasSingleCategory']),
    layout() {
      return this.hasSingleCategory ? 'full-width' : 'default';
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === Route.ProductDetails) {
      setTimeout(() => {
        if (to.hash) {
          restoreFocus(to.hash);
        } else {
          document
            .querySelector(`#${getProductLinkId(from.params.id)}`)
            ?.focus();
        }
      });
    }
    next();
  },
  beforeRouteUpdate(to, _, next) {
    if (to.hash) {
      setTimeout(() => restoreFocus(to.hash));
    }
    next();
  },
  components: {
    'w-page': Page,
    'w-category-list': CategoryList,
  },
};
</script>
